import { render } from "./IdentifyCard.vue?vue&type=template&id=8573ced2&scoped=true"
import script from "./IdentifyCard.vue?vue&type=script&lang=js"
export * from "./IdentifyCard.vue?vue&type=script&lang=js"

import "./IdentifyCard.vue?vue&type=style&index=0&id=8573ced2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8573ced2"]])

export default __exports__